import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import { Provider } from "overmind-react"
import { createOvermind } from "overmind"
import { config } from "./overmind"

import { NotificationContainer } from 'react-notifications'
import 'react-notifications/lib/notifications.css';

const overmind = createOvermind(config)

ReactDOM.render(
	<React.StrictMode>
		<Provider value={overmind}>
			<App />
			<NotificationContainer />
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
)
